import React, { Fragment } from "react";
import { useTranslation } from 'react-i18next';
import CurrencyFormat from './CurrencyFormat';

export default function (props) {
    const { product, settings } = props;
    if (settings.isPluginMode === true)
        return <Fragment />;

    const { t } = useTranslation();
    /*if (settings.isCatalogueMode === true) return <div />;*/
    const { originalPrice, specialPrice } = product;
    /*  const strikeThroughPrice = specialPrice < originalPrice ? (<del>{utils.formatCurrency(originalPrice)}</del>) : "";*/
    const strikeThroughPrice = specialPrice < originalPrice ? (<del><CurrencyFormat value={originalPrice} settings={settings} /></del>) : "";
    
    return (
        <h4 className="product-price">
            {product.hasSingleStock ? " " : `${t("starting from")} `} 
            {strikeThroughPrice}
            {/*  {utils.formatCurrency(specialPrice)}*/}
            <CurrencyFormat value={specialPrice} settings={settings} />
        </h4>
    );
}
 